export class WebhookV1StandardPayloadPolicyAssignment {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadPolicyAssignmentTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadPolicyAssignmentArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadPolicyAssignment.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadPolicyAssignmentTypeEnum;
(function (WebhookV1StandardPayloadPolicyAssignmentTypeEnum) {
    WebhookV1StandardPayloadPolicyAssignmentTypeEnum["BackupPolicyApplied"] = "BACKUP_POLICY_APPLIED";
    WebhookV1StandardPayloadPolicyAssignmentTypeEnum["BackupPolicyUnapplied"] = "BACKUP_POLICY_UNAPPLIED";
    WebhookV1StandardPayloadPolicyAssignmentTypeEnum["ClassificationPolicyApplied"] = "CLASSIFICATION_POLICY_APPLIED";
    WebhookV1StandardPayloadPolicyAssignmentTypeEnum["ClassificationPolicyUnapplied"] = "CLASSIFICATION_POLICY_UNAPPLIED";
})(WebhookV1StandardPayloadPolicyAssignmentTypeEnum || (WebhookV1StandardPayloadPolicyAssignmentTypeEnum = {}));
